import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import classnames from 'classnames';

import SearchHeader from '../main/headers/searchHeader';
import ProductsNavigation from './navigation/ProductsNavigation';
import EcommerceNavigation from './navigation/EcommerceNavigation';
import ReportsNavigation from './navigation/ReportsNavigation';
import PurchaseOrdersNavigation from './navigation/PurchaseOrdersNavigation';
import * as shapes from './shapes';
import { RoleAllowBrand } from '../auth/roleAware';
import { getShopBrand } from '../auth/selectors';
import { canUserViewReports } from '../common/helpers/users';
import { showTopNavForContainerApp } from './helpers';

const Layout = ({ canViewReports, children, ...props }) => (
  <div>
    <SearchHeader heading="Products" type="product" className="u-pr">
      <div
        className={classnames(
          'o-flexbox',
          { 'c-hide-in-container-app': !showTopNavForContainerApp(props.location.pathname) }
        )}
      >
        <EcommerceNavigation />
        <RoleAllowBrand>
          <PurchaseOrdersNavigation />
        </RoleAllowBrand>
        <ProductsNavigation />
        <ReportsNavigation
          display-if={canViewReports}
        />
      </div>
    </SearchHeader>
    { children }
  </div>
);
Layout.propTypes = {
  canViewReports: PropTypes.bool.isRequired,
  children: shapes.children.isRequired,
  location: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
  connect(state => ({
    brand: getShopBrand(state),
    canViewReports: canUserViewReports(state.auth.permissions),
  }),
  )
)(Layout);
